import { NgModule } from '@angular/core';
import { LocationStrategy, Location, HashLocationStrategy, APP_BASE_HREF } from '@angular/common';
import { provideHttpClient, HttpClient } from '@angular/common/http';
import { Routes, RouterModule } from '@angular/router';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AngularFireModule } from '@angular/fire/compat';
import { AngularFireStorageModule } from '@angular/fire/compat/storage';

import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { environment } from '@env';
import {
  AdapterService,
  AuthenService,
  AdminService,
  CommonService,
  ConfigService,
  JiraService,
  StorageService
} from '@shared/services';

import { AppComponent } from './app.component';

const BASE_ROUTES: Routes = [
  { path: '', redirectTo: 'home', pathMatch: 'full' },
  { path: '404', loadChildren: () => import('./pages/404/404.module').then(m => m.NotFoundModule) },
  { path: 'home', loadChildren: () => import('./pages/home/home.module').then(m => m.HomeModule) },
  { path: 'fine', loadChildren: () => import('./pages/fine/fine.module').then(m => m.FineModule) },
  { path: '**', redirectTo: '404' }
];

@NgModule({
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AngularFireStorageModule,
    AngularFireModule.initializeApp(environment.firebase, "cloud"),
    RouterModule.forRoot(BASE_ROUTES),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: (http: HttpClient) => new TranslateHttpLoader(http, './assets/i18n/', '.json'),
        deps: [HttpClient]
      },
      defaultLanguage: 'en'
    }),
    NgbModule
  ],
  providers: [
    { provide: APP_BASE_HREF, useValue: '/' },
    { provide: LocationStrategy, useClass: HashLocationStrategy },
    provideHttpClient(),
    Location,
    AdapterService,
    AuthenService,
    AdminService,
    CommonService,
    ConfigService,
    JiraService,
    StorageService
  ],
  declarations: [AppComponent],
  bootstrap: [AppComponent]
})
export class AppModule { }
